import { FAVORITES_SERVICE } from "@/services/favorites.service.js";

const state = {postFavoriteBySlugOutput: false, deleteFavoriteBySlugOutput: false, getFavoritesOutput: {}};

const actions = {
    //Service to add items to favorites
    postFavoriteBySlug({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('postFavoriteBySlugRequest');

        FAVORITES_SERVICE.postFavoriteBySlug(queryParams)
            .then(
                output => {
                    commit('postFavoriteBySlugSuccess', output);
                },
                error => {
                    commit('postFavoriteBySlugFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to remove items from favorites
    deleteFavoriteBySlug({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteFavoriteBySlugRequest');

        FAVORITES_SERVICE.deleteFavoriteBySlug(queryParams)
            .then(
                output => {
                    commit('deleteFavoriteBySlugSuccess', output);
                },
                error => {
                    commit('deleteFavoriteBySlugFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to list favorites
    getFavorites({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getFavoritesRequest');

        FAVORITES_SERVICE.getFavorites(queryParams)
            .then(
                output => {
                    commit('getFavoritesSuccess', output);
                },
                error => {
                    commit('getFavoritesFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postFavoriteBySlug
    postFavoriteBySlugRequest(state) {
        state.postFavoriteBySlugOutput = null;
    },
    postFavoriteBySlugSuccess(state, output) {
        state.postFavoriteBySlugOutput = true;
    },
    postFavoriteBySlugFailure(state) {
        state.postFavoriteBySlugOutput = false;
    },

    //deleteFavoriteBySlug
    deleteFavoriteBySlugRequest(state) {
        state.deleteFavoriteBySlugOutput = null;
    },
    deleteFavoriteBySlugSuccess(state, output) {
        state.deleteFavoriteBySlugOutput = true;
    },
    deleteFavoriteBySlugFailure(state) {
        state.deleteFavoriteBySlugOutput = false;
    },

    //getFavorites
    getFavoritesRequest(state) {
    },
    getFavoritesSuccess(state, output) {
        state.getFavoritesOutput = output;
    },
    getFavoritesFailure(state) {
        state.getFavoritesOutput = false;
    },
};

export const favorites = {
    namespaced: true,
    state,
    actions,
    mutations
};